var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUnion(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 20,
    viewBox: "0 0 31 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.78 2.50261H1.2513C0.560582 2.50261 0 1.94203 0 1.2513C0 0.560582 0.560582 0 1.2513 0H28.78C29.4707 0 30.0313 0.560582 30.0313 1.2513C30.0313 1.94203 29.4707 2.50261 28.78 2.50261ZM28.78 11.0112H1.2513C0.560582 11.0112 0 10.4507 0 9.75993C0 9.06921 0.560582 8.50862 1.2513 8.50862H28.78C29.4707 8.50862 30.0313 9.06921 30.0313 9.75993C30.0313 10.4507 29.4707 11.0112 28.78 11.0112ZM1.2513 19.5199H28.78C29.4707 19.5199 30.0313 18.9593 30.0313 18.2686C30.0313 17.5778 29.4707 17.0172 28.78 17.0172H1.2513C0.560582 17.0172 0 17.5778 0 18.2686C0 18.9593 0.560582 19.5199 1.2513 19.5199Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnion);
export default __webpack_public_path__ + "static/media/union.0446870de769d446212392338a0baa38.svg";
export { ForwardRef as ReactComponent };